import type { LeaseActionProps } from '../../../models/Types';
import CopyLeaseRestrictionModal from '../../CopyLeaseRestrictionModal';
import type LeaseAction from '../../../models/LeaseAction';

type Props = LeaseActionProps & {
  leaseAction: LeaseAction;
};

function OpenModalCopyLeaseRestriction({ property, history, terminateActiveAction, leaseAction }: Props) {
  const restriction = leaseAction.getRestriction();

  if (!restriction) {
    terminateActiveAction();
    return null;
  }

  return (
    <CopyLeaseRestrictionModal
      property={property}
      history={history}
      restrictionType={restriction.type}
      onClose={terminateActiveAction}
    />
  );
}

export default OpenModalCopyLeaseRestriction;
